export enum TransferPermissions {
  Transfer = 'transfer',
}
